import "./HelpCenterContent.scss"

import { forwardRef, ReactNode, useEffect } from "react"
import { useLocation } from "react-router-dom"

interface HelpCenterContentProps {
  children: ReactNode
}

const SCROLL_OFFSET = 100

const HelpCenterContent = forwardRef<HTMLDivElement, HelpCenterContentProps>(
  function HelpCenterContent(props, ref) {
    const location = useLocation()

    useEffect(() => {
      const hash = location.hash.slice(1)
      if (hash) {
        setTimeout(() => {
          const element = document.getElementById(hash)
          if (element) {
            const elementPosition = element.getBoundingClientRect().top
            const offsetPosition = elementPosition + window.pageYOffset - SCROLL_OFFSET
            window.scrollTo({ top: offsetPosition, behavior: "smooth" })
          }
        }, 100)
      }
    }, [location.hash])

    return (
      <div ref={ref} className="help-center-content">
        {props.children}
      </div>
    )
  }
)

export default HelpCenterContent
